class Render {
    constructor(context, shape) {
        this.context = context;
        this.shape = shape;
    }
    draw() {
        if (typeof this.shape.render === 'string') {
            switch (this.shape.render) {
                case 'img':
                    this.drawImg();
                    break;
                case 'img-circle':
                    this.drawCircleImg();
                    break;
                case 'img-clip':
                    this.drawImgClip();
                    break;
                case 'text':
                    this.fillText();
                    break;
            }
        }
        else if (typeof this.shape.render === 'function') {
            this.shape.render.call(this, this.context, this.shape);
        }
    }
    drawImg() {
        let shape = this.shape, pos = shape.offset, r = shape.other && shape.other.radius || 0, PI = Math.PI, ctx = this.context;
        if (r > 0) {
            ctx.save();
            ctx.translate(pos.left, pos.top);
            ctx.moveTo(0, r);
            ctx.arc(r, r, r, PI, 1.5 * PI);
            ctx.lineTo(pos.width - r, 0);
            ctx.arc(pos.width - r, r, r, 1.5 * PI, 0);
            ctx.lineTo(pos.width, pos.height - r);
            ctx.arc(pos.width - r, pos.height - r, r, 0, 0.5 * PI);
            ctx.lineTo(r, pos.height);
            ctx.arc(r, pos.height - r, r, 0.5 * PI, PI);
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(shape.content, 0, 0, pos.width, pos.height);
            ctx.restore();
        }
        else {
            ctx.drawImage(shape.content, pos.left, pos.top, pos.width, pos.height);
        }
    }
    drawImgClip() {
        let shape = this.shape, pos = shape.offset, { realWidth, realHeight } = shape.other, r = shape.other && shape.other.radius || 0, PI = Math.PI, ctx = this.context;
        let x, y, w, h;
        if (realWidth / realHeight > pos.width / pos.height) {
            const ratio = pos.height / realHeight;
            x = (realWidth * ratio - pos.width) / 2;
            y = 0;
            w = pos.width;
            h = pos.height;
            x = x / ratio;
            y = y / ratio;
            w = w / ratio;
            h = h / ratio;
        }
        else {
            const ratio = pos.width / realWidth;
            x = 0;
            y = (realHeight * ratio - pos.height) / 2;
            w = pos.width;
            h = pos.height;
            x = x / ratio;
            y = y / ratio;
            w = w / ratio;
            h = h / ratio;
        }
        if (r > 0) {
            ctx.save();
            ctx.translate(pos.left, pos.top);
            ctx.moveTo(0, r);
            ctx.arc(r, r, r, PI, 1.5 * PI);
            ctx.lineTo(pos.width - r, 0);
            ctx.arc(pos.width - r, r, r, 1.5 * PI, 0);
            ctx.lineTo(pos.width, pos.height - r);
            ctx.arc(pos.width - r, pos.height - r, r, 0, 0.5 * PI);
            ctx.lineTo(r, pos.height);
            ctx.arc(r, pos.height - r, r, 0.5 * PI, PI);
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(shape.content, x, y, w, h, 0, 0, pos.width, pos.height);
            ctx.restore();
        }
        else {
            ctx.drawImage(shape.content, x, y, w, h, pos.left, pos.top, pos.width, pos.height);
        }
    }
    drawCircleImg() {
        let shape = this.shape, ctx = this.context, pos = shape.offset, r = shape.offset.width / 2;
        ctx.beginPath();
        ctx.arc(pos.left + r, pos.top + r, r, 0, 2 * Math.PI);
        ctx.closePath();
        ctx.strokeStyle = "transparent";
        ctx.stroke();
        ctx.clip();
        ctx.drawImage(shape.content, pos.left, pos.top, pos.width, pos.height);
    }
    fillText() {
        let shape = this.shape, pos = shape.offset, other = shape.other, ctx = this.context, rowNum = Math.floor(pos.height / other.lineHeight), fontHeight = other.font.match(/(\d+)px/) ? +other.font.match(/(\d+)px/)[1] : other.lineHeight;
        ctx.fillStyle = other.color;
        ctx.strokeStyle = other.color;
        ctx.font = other.font;
        ctx.textBaseline = 'top'; //暂时不考虑动态配置,只用top
        let arr = [], paragraphs = shape.content;
        arr = measure(ctx, paragraphs, pos.width, rowNum);
        arr.forEach((content, index) => {
            ctx.fillText(content, pos.left, pos.top + other.lineHeight * index + (other.lineHeight - fontHeight) / 2, pos.width);
        });
    }
}
export function util(context) {
    const util = {
        //给定文本和相关参数,计算出文本所占高度.
        autoTextHeight: function (width, shape) {
            let paragraphs = shape.content;
            context.save();
            context.strokeStyle = shape.other.color;
            context.font = shape.other.font;
            context.textBaseline = 'top'; //暂时不考虑动态配置,只用top
            let arr = measure(context, paragraphs, width);
            context.restore();
            return shape.other.lineHeight * arr.length;
        },
        autoImgHeight: function (width, shape) {
            let { realHeight, realWidth } = shape.other;
            return width * realHeight / realWidth;
        },
        //计算单行文本的长度
        calcTextWidth: function (width, shape) {
            context.save();
            context.strokeStyle = shape.other.color;
            context.font = shape.other.font;
            context.textBaseline = 'top'; //暂时不考虑动态配置,只用top
            let textWidth = Math.ceil(context.measureText(shape.content).width) + 1;
            context.restore();
            return textWidth > width ? width : textWidth;
        }
    };
    return util;
}
;
function lineTest(ctx, words, width) {
    let pointer = 1, testWords = words.slice(0, pointer);
    while (ctx.measureText(testWords).width <= width && pointer <= words.length) {
        pointer++;
        testWords = words.slice(0, pointer);
    }
    return {
        pointer: pointer - 1,
        content: words.slice(0, pointer - 1)
    };
}
//一段文字,在给定宽度下,分割成的行数.如果有最大行数,则最后一行可能要处理成省略号.
export function measure(context, paragraphs, width, rowNum) {
    let arr = [], line;
    paragraphs.forEach(content => {
        do {
            line = lineTest(context, content, width);
            arr.push(line.content);
            content = content.slice(line.pointer);
        } while (content);
    });
    if (rowNum && rowNum < arr.length) {
        let lastLine = arr[rowNum - 1];
        arr = arr.slice(0, rowNum - 1);
        let ellipsis = lineTest(context, lastLine, width);
        arr.push(ellipsis.content.slice(0, ellipsis.content.length - 1) + '...');
    }
    return arr;
}
export default Render;
